import React from 'react';
import { dotStyle, flex } from '@fabric-ui/theme';
import { stringToColor } from '@fabric-ui/utils';
import { Box, useTheme } from '@mui/material';

interface AvAvatarProps {
  displayName?: string;
  size?: number;
}

export const AvAvatar: React.FC<AvAvatarProps> = ({ displayName = 'Unknown', size = 12 }) => {
  const theme = useTheme();
  const initials = displayName
    .split(' ')
    .slice(0, 2)
    .map(n => n[0]);

  return (
    <Box
      component="span"
      sx={{
        ...flex.center,
        backgroundColor: stringToColor(displayName, theme.palette.avatarColors),
        ...dotStyle(undefined, '100%' as any),
      }}>
      <Box
        sx={{
          fontWeight: 600,
          fontSize: size,
          color: theme.palette.white.main,
          textTransform: 'uppercase',
        }}>
        {initials}
      </Box>
    </Box>
  );
};
